import { Type } from "class-transformer";

export class ClientSignUpData {
  phoneNumber!: string;
  firstName!: string;
  lastName!: string;
  password!: string;
  otp!: string;
  subAdvisorId!: string;
  refId?: string;
  campaign?: string;
}

export class AdvisorInfo {
  advisorName!: string;
  image_banner!: string;
  image_logo!: string;
  image_splash!: string;
  title!: string;
  subtitle!: string;
  phone!: string;
}

export class GenerateOtp {
  result!: string;
}

export class OtpVerification {
  developerMsg!: string;
  userMsg!: string;
}

export type UserSignUP = {
  phoneNumber: string;
  firstName: string;
  lastName: string;
  password: string;
  otp: string;
  subAdvisorId: string;
  refId?: string;
  email?: string;
};

export class SignUpResponse {
  @Type(() => UserData)
  user!: UserData;
  token!: string;
  @Type(() => UserData)
  members!: UserData[];
}

export class UserData {
  user!: {
    activationStatus: {
      status: string;
      kyc: string;
      rejectedParams: [];
      rejectionCategories: [];
    };
    device: {};
    lastName: string;
    kycStatus: string;
    activationUpdated: string;
    allowPortfolioAccess: boolean;
    freezeNAV: boolean;
    _id: string;
    phoneNumber: number;
    firstName: string;
    subAdvisorId: string;
    city: string;
    state: string;
    createdAt: string;
    updatedAt: string;
    bseClientCode: number;
    lastIssuedAt: number;
    id: string;
  };
  token!: string;
}
